import React, { useEffect, useState } from "react";

export default function useOnScreen(ref: React.MutableRefObject<any>) {
    // State and setter for storing whether element is visible
    const [isIntersecting, setIntersecting] = useState(false);
    useEffect(() => {
      const observer = new IntersectionObserver((entries) => {
        let flag = false;
        for(let i = 0; i < entries.length; ++i) {
          if (entries[i].isIntersecting) {
            flag = true;
          }
        }
        setIntersecting(flag);
      });
      if (ref.current) {
        observer.observe(ref.current);
      }
      return () => {
        observer.disconnect();
      };
    }, [ref]); // Empty array ensures that effect is only run on mount and unmount
    
    return isIntersecting;
  }